import {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useMemo,
} from "react";
import { useFieldArray, FormProvider, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  useDataProvider,
  useNotify,
  useRefresh,
  Confirm,
  useGetOne,
  useStore,
} from "react-admin";
import YesNoRadioButton from "../../../componets/common/InputComponents/YesNoRadioButton";
import overa from "../../../assets/images/overa.svg";
import redTick from "../../../assets/images/redTick.svg";
import greenTick from "../../../assets/images/greenTick.svg";
import Card from "@mui/material/Card";
import { CardHeader } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import AlertDialogEmp from "../../common/AlertDialogEmp";
import { NumericFormat } from "react-number-format";
import debouce from "lodash.debounce";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store/store";
import { useParams } from "react-router-dom";
import EmployerSource from "./EmployerSource";
import PlaidEmployerSource from "./PlaidEmployerSource";
import NoProofEmploymentReasonModal from "./NoProofEmploymentReasonModal";
import EmployerVerificationChooser from "./EmployerVerificationChooser";
import { useUserRole } from "../../../ContextApi/UserRoleContext";
import { TotalGrossPay } from "../../../utils/TotalGrossPay";
import pencilIcon from "../../../assets/images/pencilIcon.svg";
import { scrollToAnchor } from "./scrollToAnchor";
import { argyleVerboseLog } from "../argyleVerboseLogging";
export interface ValidationMessageStatu {
  type: string;
  key: boolean;
  message: string;
}

export interface Earning {
  ID: string;
  earning_name: string;
  earning_type: string;
  current: number;
  ytd: number;
  calculatedCurrent: number;
  calculatedYtd: number;
}

export interface Deduction {
  ID: string;
  deduction_name: string;
  deduction_type: string;
  current: number;
  ytd: number;
  calculatedCurrent: number;
  calculatedYtd: number;
}

export interface SummaryTable {
  ID: string;
  table_header: string;
  displayedCurrent: number;
  displayedYtd: number;
  calculatedCurrent: number;
  calculatedYtd: number;
}

export interface File {
  income_row_id: string;
  application_document_id: string;
  path: string;
  path_image: string;
  file_name: string;
  Start_date: Date;
  End_date: Date;
  Pay_date: Date;
  Pay_frequency: string;
  Gross_Pay: number;
  Net_Pay: number;
  doc_state_type: string;
  calculated_net_pay: number;
  calculated_gross_pay: number;
  gross_pay_ytd?: any;
  annual_income: number;
  monthly_income: number;
  All_text?: any;
  is_Duplicate: number;
  paystub_type: string;
  socr_error_fields: any[];
  isActive: boolean;
  OCRcomplted: boolean;
  isReprocess: boolean;
  isFlagPaystub: boolean;
  isFlagSocrFields: boolean;
  earnings: Earning[];
  deduction: Deduction[];
  summaryTable: SummaryTable[];
}

export interface Employer {
  id: string;
  application_id: string;
  applicant_id: string;
  subscriber_id: string;
  employer_name: string;
  position: string;
  phone_no?: any;
  employer_address: string;
  employer_city: string;
  employer_state: string;
  employer_status: string;
  employer_zipcode: string;
  employment_start_date?: any;
  employment_end_date?: any;
  iscurrent_employer: boolean;
  isfuture_employer: boolean;
  manager_name: string;
  no_doc_reason?: any;
  other_reason?: any;
  total_income?: any;
  total_annual_income?: any;
  monthly_avr_gross?: any;
  validation_message_status: ValidationMessageStatu[];
  avrgross_pay?: any;
  pay_frequency: string;
  files: File[];
  EmployeeFirstName?: any;
  EmployeeMiddleName?: any;
  EmployeeLastName?: any;
  EmployerAddress: string;
  EmployeeState?: any;
  EmployeeCity?: any;
  CalculatedTotalIncome: number;
  CalculatedTotalAnnualIncome: number;
  EmployerCode?: any;
  EmployeeID?: any;
  EmployerNumber: number;
  ReportedTotalIncome?: any;
  ReportedTotalAnnualIncome?: any;
  isReportedEqualsMonthly: boolean;
  CreatedBy: string;
  CreatedOn: Date;
  ModifiedBy?: any;
  ModifiedOn?: any;
  section_comment: string;
  isReprocess: number;
  correctedDocType: any;
  allowOfferLetter?: any;
  availableToUpload: any;
  fileCount: any;
}

export interface SOCRstatus {
  Source_1?: any;
  Source_2?: any;
  Source_3?: any;
}

export interface RootObject {
  Question: string;
  employment_status?: string;
  proof_response?: string;
  employment_no_doc_reason?: any;
  employment_other_reason?: any;
  proof_no_doc_reason?: any;
  proof_other_reason?: any;
  response?: string | null;
  no_doc_reason?: any;
  other_reason?: any;
  employer: Employer[];
  SOCRstatus: SOCRstatus;
}

type NoReasonOption = {
  name: string;
  value: string;
};

const EMPLOYMENT_STATUS_QUESTION = "Are you currently employed?";
const PROOF_OF_EMPLOYMENT_QUESTION =
  "Are you ready to verify your income?";

const EMPLOYMENT_STATUS_NO_OPTIONS: NoReasonOption[] = [
  { name: "Full-time student", value: "Full-time student" },
  { name: "Not Currently Employed", value: "Not Currently Employed" },
  { name: "Retired", value: "Retired" },
  { name: "Other (please specify)", value: "Other" },
];

const LEGACY_PROOF_NO_ACCESS_REASON =
  "I do not currently have access to document(s), but can provide later";
const LEGACY_PROOF_NO_PROOF_REASON = "I do not have proof of Income";
const LEGACY_PROOF_NO_OPTIONS: NoReasonOption[] = [
  {
    name: LEGACY_PROOF_NO_ACCESS_REASON,
    value: LEGACY_PROOF_NO_ACCESS_REASON,
  },
  {
    name: LEGACY_PROOF_NO_PROOF_REASON,
    value: LEGACY_PROOF_NO_PROOF_REASON,
  },
  {
    name: "Other",
    value: "other",
  },
];
const MAX_OTHER_REASON_LENGTH = 400;

const normalizeReason = (value?: string | null) =>
  (value || "").toString().trim().toLowerCase();

const EMPLOYMENT_REASON_VALUES = EMPLOYMENT_STATUS_NO_OPTIONS.map(
  (option) => option.value
);
const PROOF_REASON_VALUES = LEGACY_PROOF_NO_OPTIONS.map((option) => option.value);

const mapReasonExactOrOther = (
  reasonRaw: string | null | undefined,
  otherRaw: string | null | undefined,
  allowedValues: string[],
  otherOptionValue: string
) => {
  const reasonText = reasonRaw == null ? "" : String(reasonRaw);
  const otherText = otherRaw == null ? "" : String(otherRaw);
  if (!reasonText) return { reason: null, other: null };

  if (allowedValues.includes(reasonText)) {
    if (reasonText !== otherOptionValue) return { reason: reasonText, other: null };
    return {
      reason: otherOptionValue,
      other: otherText || null,
    };
  }

  return {
    reason: otherOptionValue,
    other: otherText || reasonText,
  };
};

const parseSourceId = (value: any): number | null => {
  const parsed = Number.parseInt(String(value), 10);
  if (!Number.isFinite(parsed) || parsed < 1 || parsed > 3) return null;
  return parsed;
};

export function mergeServerSourceStatuses(
  payrollSourceStatuses: any[] | undefined,
  argyleSourceStatuses: any[] | undefined,
  maxEmployers = 3
) {
  const statusBySource = new Map<
    number,
    "pending" | "valid" | "linked" | "linked_no_data" | "none"
  >(
    Array.from({ length: maxEmployers }, (_, index) => [index + 1, "none"])
  );

  (Array.isArray(payrollSourceStatuses) ? payrollSourceStatuses : []).forEach(
    (item: any) => {
      const sourceId = parseSourceId(item?.source_id);
      const rawStatus = String(item?.status || "")
        .trim()
        .toLowerCase();
      if (!sourceId) return;
      if (rawStatus !== "pending" && rawStatus !== "valid" && rawStatus !== "none") {
        return;
      }
      statusBySource.set(sourceId, rawStatus as "pending" | "valid" | "none");
    }
  );

  (Array.isArray(argyleSourceStatuses) ? argyleSourceStatuses : []).forEach(
    (item: any) => {
      const sourceId = parseSourceId(item?.source_id);
      const rawStatus = String(item?.status || "")
        .trim()
        .toLowerCase();
      if (!sourceId) return;
      if (
        rawStatus !== "pending" &&
        rawStatus !== "linked_no_data" &&
        rawStatus !== "linked" &&
        rawStatus !== "none"
      ) {
        return;
      }
      if (rawStatus === "none" && statusBySource.get(sourceId) !== "none") {
        return;
      }
      statusBySource.set(
        sourceId,
        rawStatus as "pending" | "linked_no_data" | "linked" | "none"
      );
    }
  );

  return statusBySource;
}
const LOCAL_PENDING_SOURCE_TTL_MS = 600000;

type MergedSourceItem =
  | {
      sourceId: number;
      kind: "payroll";
      payrollEmployer: any;
    }
  | {
      sourceId: number;
      kind: "document";
      field: any;
      index: number;
    }
  | {
      sourceId: number;
      kind: "chooser";
      field: any;
      index: number;
      employerId: string;
    }
  | {
      sourceId: number;
      kind: "loading";
    };

const ProofOfEmploymentIncome = forwardRef((props: any, ref) => {
  const refresh = useRefresh();
 const { role: userRoleContext } = useUserRole();
  const trn_id = props.IncomeAPIResponse.data.trn_id; // useSelector((state: RootState) => state.users.userTrnId);
  const {
    IncomeAPIResponse,
    LookbacksData,
    payrollPlaidEnabled,
    payrollValidationLoading = false,
    payrollEmployers,
    payrollSourceStatuses,
    argyleSourceStatuses,
  } = props;
  const { appType } = useParams();
  const invitationType: any = appType;
  const [filePreview, setFilePreview] = useState({
    proof_of_income: "",
    proof_of_income_filePath: "",
  });
  const dataProvider = useDataProvider();
  const queryClient = useQueryClient();
  const notify = useNotify();
  const roleRedux: any = useSelector((state: RootState) => state.users.role);
  const role = userRoleContext || roleRedux;
  const normalizedRole = (roleRedux || userRoleContext || "").toString().toLowerCase();
  const bankLookbackMonths = Number(LookbacksData?.bank_lookback) || null;
  const [mlClassDetails, setMlClassDetails] = useState([]);

  const submitButtonRef = useRef<HTMLButtonElement>(null);
  const pendingAddSourceIdRef = useRef<number | null>(null);
  const employerActionLockRef = useRef(false);
  const [localPayrollPendingBySource, setLocalPayrollPendingBySource] = useState<
    Record<number, { createdAt: number; acknowledgedByServer: boolean }>
  >({});
  const [employerActionLocked, setEmployerActionLocked] = useState(false);

  useImperativeHandle(ref, () => ({ handleClickByRef, handleSubmitManual }));

  const isOtherReason = (value?: string | null) =>
    normalizeReason(value) === "other";
  const sanitizeOtherReason = (value?: string | null) =>
    String(value || "").slice(0, MAX_OTHER_REASON_LENGTH).trim();
  const getReasonDisplayValue = (reason?: string | null, otherReason?: string | null) => {
    if (isOtherReason(reason) && String(otherReason || "").trim()) {
      return String(otherReason).trim();
    }
    return reason || "-";
  };
  const reasonEditButtonStyle = {
    width: 28,
    height: 28,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const reasonEditIconStyle = { width: 16, height: 16 };
  const reasonTextWrapStyle = {
    overflowWrap: "anywhere" as const,
    wordBreak: "break-word" as const,
    whiteSpace: "pre-wrap" as const,
  };

  const baseRequiredSchema = Yup.object({
    employment_status: Yup.string().required("required").typeError("required"),
    proof_response: Yup.string().when("employment_status", {
      is: (value) => value === "Yes",
      then: Yup.string().required("required").typeError("required"),
      otherwise: Yup.string().nullable(),
    }),
    employment_no_doc_reason: Yup.string().when("employment_status", {
      is: (value) => value === "No",
      then: Yup.string().required("Required").typeError("required"),
      otherwise: Yup.string().nullable(),
    }),
    employment_other_reason: Yup.string().when(
      ["employment_status", "employment_no_doc_reason"],
      {
        is: (employmentStatus, noDocReason) =>
          employmentStatus === "No" && isOtherReason(noDocReason),
        then: Yup.string()
          .typeError("required")
          .required("Required")
          .max(MAX_OTHER_REASON_LENGTH, `Maximum ${MAX_OTHER_REASON_LENGTH} characters allowed`)
          .matches(/^$|^\S+.*/g, "Enter a valid value"),
        otherwise: Yup.string().nullable(),
      }
    ),
    proof_no_doc_reason: Yup.string().when(
      ["employment_status", "proof_response"],
      {
        is: (employmentStatus, proofResponse) =>
          employmentStatus === "Yes" && proofResponse === "No",
        then: Yup.string().required("Required").typeError("required"),
        otherwise: Yup.string().nullable(),
      }
    ),
    proof_other_reason: Yup.string().when(
      ["employment_status", "proof_response", "proof_no_doc_reason"],
      {
        is: (employmentStatus, proofResponse, noDocReason) =>
          employmentStatus === "Yes" &&
          proofResponse === "No" &&
          isOtherReason(noDocReason),
        then: Yup.string()
          .typeError("required")
          .required("Required")
          .max(MAX_OTHER_REASON_LENGTH, `Maximum ${MAX_OTHER_REASON_LENGTH} characters allowed`)
          .matches(/^$|^\S+.*/g, "Enter a valid value"),
        otherwise: Yup.string().nullable(),
      }
    ),
  });

  const localSchema = baseRequiredSchema.shape({
    employer: Yup.array().when(["employment_status", "proof_response"], {
      is: (employmentStatus, proofResponse) =>
        employmentStatus === "Yes" && proofResponse === "Yes",
      then: Yup.array().nullable(),
      otherwise: Yup.array().nullable(),
    }),
  });

  const schema = baseRequiredSchema;

  const schemaNotRequired = Yup.object({
    employment_status: Yup.string().nullable(),
    proof_response: Yup.string().nullable(),
    employment_no_doc_reason: Yup.string().nullable(),
    employment_other_reason: Yup.string().nullable(),
    proof_no_doc_reason: Yup.string().nullable(),
    proof_other_reason: Yup.string().nullable(),
  });

  const getSchema = () => {
    if (props.required) {
      if (role === "applicant") {
        return localSchema;
      } else {
        return schema;
      }
    } else {
      return schemaNotRequired;
    }
  };

  const methods = useForm<RootObject>({
    resolver: yupResolver(getSchema()),
    mode: "onChange",
  });
  // const methods = useForm<RootObject>();

  async function handleClickByRef() {
    submitButtonRef?.current?.click();
    const isValidForm = await methods.trigger();
    if (!isValidForm) return false;

    if (
      role === "applicant" &&
      methods.getValues("employment_status") === "Yes" &&
      methods.getValues("proof_response") === "Yes" &&
      !hasCompleteEmploymentProofForAllSources
    ) {
      mergedSourceItems.forEach((item) => {
        if (!isSourceProofComplete(item) && (item.kind === "document" || item.kind === "chooser")) {
          const employerIndex = typeof item.index === "number" ? item.index : item.sourceId - 1;
          methods.setError(`employer.${employerIndex}.files` as any, {
            type: "manual",
            message: "Upload files, connect payroll, or remove this employer.",
          });
        }
      });
      methods.setError("proof_response", {
        type: "manual",
        message:
          "Complete each employer source with pay stubs or payroll before continuing.",
      });
      return false;
    }

    return true;
  }

  const MAX_EMPLOYERS = 3;

  const [confirmDeleteSource, setConfirmDeleteSource] = useState(false);
  const [employerNumber, serEmployerNumber] = useState<any>(0);
  const [hasAutoCreatedEmployer, setHasAutoCreatedEmployer] = useState(false);
  const [employmentNoReasonModalOpen, setEmploymentNoReasonModalOpen] =
    useState(false);
  const [
    clearEmploymentStatusOnNoReasonCancel,
    setClearEmploymentStatusOnNoReasonCancel,
  ] = useState(true);
  const [pendingEmploymentNoReason, setPendingEmploymentNoReason] = useState("");
  const [pendingEmploymentOtherReason, setPendingEmploymentOtherReason] =
    useState("");
  const [proofNoReasonModalOpen, setProofNoReasonModalOpen] = useState(false);
  const [clearProofResponseOnNoReasonCancel, setClearProofResponseOnNoReasonCancel] =
    useState(true);
  const [pendingProofNoReason, setPendingProofNoReason] = useState("");
  const [pendingProofOtherReason, setPendingProofOtherReason] = useState("");
  const [documentModeByEmployer, setDocumentModeByEmployer] = useState<
    Record<string, boolean>
  >({});
  const [mannualSOCRstatus] = useState({
    Source_1: null,
    Source_2: null,
    Source_3: null,
  });

  const [socrStatus, setSocrStatus] = useState({
    Source_1: {
      SOCRStatus: null,
      concurrent: null,
      current: null,
      look_back: null,
      look_back_period: "",
      name_match: null,
      no_of_weeks: "",
      total_gross: 0,
    },
    Source_2: {
      SOCRStatus: null,
      concurrent: null,
      current: null,
      look_back: null,
      look_back_period: "",
      name_match: null,
      no_of_weeks: "",
      total_gross: 0,
    },
    Source_3: {
      SOCRStatus: null,
      concurrent: null,
      current: null,
      look_back: null,
      look_back_period: "",
      name_match: null,
      no_of_weeks: "",
      total_gross: 0,
    },
  });

  const { control } = methods;
  const { fields } = useFieldArray(
    {
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "employer", // unique name for your Field Array
      keyName: "fieldId",
    }
  );

  const { data: meta_d_response } = useGetOne(
    "getMetaData",
    { id: 3, meta: { trn_id } },
    { refetchOnWindowFocus: false }
  );

  const fetchMlclassDetails = async () => {
    try {
      let data: any = {};
      data = await dataProvider.paystubProcessing({
        subUrl: "/document/GetMLclassDetails",
        DocumentTypeID: 3,
        method: "POST",
      });
      let mlClassArray = data?.data?.records?.map((record) => ({
        value: record.ID,
        label: record.ClassName,
      }));
      setMlClassDetails(mlClassArray);
    } catch (err) {
      notify("Error fetching emplyment details", {
        type: "warning",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    }
  };

  useEffect(() => {
    fetchMlclassDetails();
  }, []);

  const [adminValidationMessages, setAdminValidationMessages] = useState({
    Source_1: [],
    Source_2: [],
    Source_3: [],
  } as any);

  useEffect(() => {
    if (meta_d_response?.records && role !== "applicant") {
      const { validation_messages, other_check } = meta_d_response?.records;
      if (validation_messages) {
        const admin_messages_source_1 = validation_messages?.source_1.map(
          (message) => ({
            ...message.admin,
          })
        );
        const admin_messages_source_2 = validation_messages?.source_2.map(
          (message) => ({
            ...message.admin,
          })
        );
        const admin_messages_source_3 = validation_messages?.source_3.map(
          (message) => ({
            ...message.admin,
          })
        );
        const admin_validation_messages = {
          Source_1: admin_messages_source_1,
          Source_2: admin_messages_source_2,
          Source_3: admin_messages_source_3,
        };
        setAdminValidationMessages(admin_validation_messages);
      }
      if (other_check) {
        setSocrStatus(other_check);
      }
    }
  }, [meta_d_response]);

  const { mutateAsync: updateEmployerAsync } = useMutation(
    "updateEmployer",
    (data: any) =>
      dataProvider.update("other_sections", {
        id: data.id,
        data: data.data,
        previousData: data.previousData,
      }),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(["getMetaData"]);
        queryClient.invalidateQueries(["getEmployerValidationCheck"]);
        if (role !== "applicant") {
          queryClient.invalidateQueries({ queryKey: ["income"] });

          notify("Employer details successfully saved.", {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
          // refresh();
        }
      },
      onError: (data) => {
        alert("Fail updating employer details");
      },
      onMutate: () => {
        // debugger;
        if (role !== "applicant") {
          notify("Updating employer details...", {
            type: "info",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        }
      },
    }
  );

  // const onSubmitEmpty = (val) => null;

  const handleSubmitManual = () => {
    if (role === "applicant") {
      submitButtonRef?.current?.click();
    } else {
      OnSubmitIncome(methods.getValues());
    }
  };

  const transformEmployersForPayload = (employers: Employer[] = []) =>
    employers.map((obj: any) => {
      const sourceId = parseSourceId(obj?.source_id ?? obj?.EmployerNumber);
      const filesObjArray = (obj?.files || []).map((fileObj) => ({
        ...fileObj,
        Pay_frequency: fileObj?.Pay_frequency?.value || fileObj?.Pay_frequency,
      }));
      return {
        ...obj,
        source_id: sourceId,
        availableToUpload: "Yes",
        files: filesObjArray,
        fileCount: filesObjArray.length,
        other_reason:
          obj?.availableToUpload !== "Yes" && isOtherReason(obj?.no_doc_reason)
            ? obj?.other_reason
            : null,
        phone_no: obj?.country_code
          ? obj.phone_no?.split(obj?.country_code)?.[1]
            ? obj.phone_no
            : null
          : obj.phone_no,
        no_doc_reason: obj?.availableToUpload !== "Yes" ? obj?.no_doc_reason : null,
      };
    });

  const buildEncodedEmploymentValues = (value: RootObject) => {
    const employmentStatus = value?.employment_status;
    const proofResponse = value?.proof_response;

    if (employmentStatus === "No") {
      const noDocReason = value?.employment_no_doc_reason || null;
      return {
        response: "No",
        no_doc_reason: noDocReason,
        other_reason: isOtherReason(noDocReason)
          ? sanitizeOtherReason(value?.employment_other_reason) || null
          : null,
      };
    }

    if (employmentStatus === "Yes") {
      if (proofResponse === "No") {
        const noDocReason = value?.proof_no_doc_reason || null;
        return {
          response: "No",
          no_doc_reason: noDocReason,
          other_reason: isOtherReason(noDocReason)
            ? sanitizeOtherReason(value?.proof_other_reason) || null
            : null,
        };
      }

      if (proofResponse === "Yes") {
        const noDocReason = value?.proof_no_doc_reason || null;
        return {
          response: "Yes",
          no_doc_reason: noDocReason,
          other_reason: isOtherReason(noDocReason)
            ? sanitizeOtherReason(value?.proof_other_reason) || null
            : null,
        };
      }
    }

    return {
      response: null,
      no_doc_reason: null,
      other_reason: null,
    };
  };

  const saveQueueRef = useRef<Promise<any>>(Promise.resolve());
  const OnSubmitIncome = (value: RootObject) => {
    const employerPayload = transformEmployersForPayload(value?.employer || []);
    const encodedValues = buildEncodedEmploymentValues(value);
    const employmentDetailsPayload: any = {
      ...value,
      Question: EMPLOYMENT_STATUS_QUESTION,
      response: encodedValues.response,
      no_doc_reason: encodedValues.no_doc_reason,
      other_reason: encodedValues.other_reason,
      employer: employerPayload,
      employerCount: employerPayload.length,
    };

    delete employmentDetailsPayload.SOCRstatus;
    delete employmentDetailsPayload.proof_response;
    delete employmentDetailsPayload.proof_no_doc_reason;
    delete employmentDetailsPayload.proof_other_reason;

    const final_paylaod = {
      employment_details: employmentDetailsPayload,
      trn_id: trn_id,
      subUrl: "/income/SaveEmployerSection",
    };

    saveQueueRef.current = saveQueueRef.current
      .catch(() => null)
      .then(() =>
        updateEmployerAsync({
          id: trn_id,
          data: final_paylaod,
          previousData: [],
        })
      );
  };
  // const formsChildContext = useContext(FormsChildContext);
  useEffect(() => {
    // formsChildContext?.updateFormAtIndex(props.index,{ ...formsChildContext?.forms, incomeSection: methods.formState?.errors })
    props.setChildFormError(methods.formState?.errors);
  }, [methods.formState]);

  const [disableNewBtn, setdisableNewBtn] = useState(false);
  const lockEmployerActions = () => {
    employerActionLockRef.current = true;
    setEmployerActionLocked(true);
  };
  const unlockEmployerActions = () => {
    employerActionLockRef.current = false;
    setEmployerActionLocked(false);
  };
  const {
    mutate: createNewEmployer,
    isLoading: loadingcreateNewEmployer,
  } = useMutation(
    "createNewEmployer",
    (data: any) => {
      return dataProvider.create("income", {
        data: {
          document_id: data.document_id,
          source_id: data.source_id,
          verification_type: data.verification_type,
          trn_id: data.trn_id,
        },
      });
    },
    {
      onSuccess: async () => {
        try {
          await queryClient.invalidateQueries(["income"]);
          await queryClient.invalidateQueries(["getsectionavailable"]);
          await queryClient.invalidateQueries(["plaidPayrollIncomeValidationCheck"]);
          await queryClient.invalidateQueries(["argylePayrollIncomeValidationCheck"]);
          const addedSourceId = pendingAddSourceIdRef.current;
          if (addedSourceId) {
            scrollToAnchor(`employment-source-${addedSourceId}`, 3000);
          }
          pendingAddSourceIdRef.current = null;
          notify("New employer added successfully", {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
          setdisableNewBtn(false);
        } finally {
          unlockEmployerActions();
        }
      },
      onError: () => {
        queryClient.invalidateQueries(["income"]);
        queryClient.invalidateQueries(["plaidPayrollIncomeValidationCheck"]);
        queryClient.invalidateQueries(["argylePayrollIncomeValidationCheck"]);
        notify("Employer sources changed. We refreshed this section—please try again.", {
          type: "warning",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        pendingAddSourceIdRef.current = null;
        setHasAutoCreatedEmployer(false);
        setdisableNewBtn(false);
        unlockEmployerActions();
      },
      onMutate: () => {
        notify("Adding new employer...", {
          type: "info",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      },
    }
  );

  const {
    mutate: employerProcessing,
    isLoading: deleteemployerProcessing,
  } = useMutation(
    "employerProcessing",
    (data: any) => dataProvider.paystubProcessing({ ...data }),
    {
      onSuccess: (_data, variables: any) => {
        queryClient.invalidateQueries(["income"]);
        queryClient.invalidateQueries(["getEmployerValidationCheck"]);
        queryClient.invalidateQueries(["plaidPayrollIncomeValidationCheck"]);
        queryClient.invalidateQueries(["argylePayrollIncomeValidationCheck"]);
        if (variables?.subUrl === "/income/deleteSource") {
          notify("Employer removed", {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        }
      },
      onError: () => {
        setConfirmDeleteSource(false);
      },
      onSettled: () => {
        unlockEmployerActions();
      },
      onMutate: (variables: any) => {
        notify(
          variables?.subUrl === "/income/deleteSource"
            ? "Deleting employer..."
            : "Processing employer...",
          {
            type: "info",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          }
        );
        setConfirmDeleteSource(false);
      },
    }
  );

  const isEmployerActionBusy = () =>
    employerActionLockRef.current ||
    loadingcreateNewEmployer ||
    deleteemployerProcessing;

  useEffect(() => {
    setdisableNewBtn(false);
  }, [fields.length]);

  useEffect(() => {
    setDocumentModeByEmployer((previous) => {
      const next = { ...previous };
      const activeEmployerIds = new Set<string>();

      fields.forEach((field: any, index: number) => {
        const employerId = String(field?.id ?? field?.EmployerNumber ?? index);
        activeEmployerIds.add(employerId);
        if (Array.isArray(field?.files) && field.files.length > 0) {
          next[employerId] = true;
        }
      });

      Object.keys(next).forEach((employerId) => {
        if (!activeEmployerIds.has(employerId)) {
          delete next[employerId];
        }
      });

      return next;
    });
  }, [fields]);

  const isPayrollPlaidEnabled = Boolean(payrollPlaidEnabled);
  const proofYesHelperText =
    isPayrollPlaidEnabled
      ? " - Click 'Yes' to upload pay stubs or connect to your employer"
      : " - Click 'Yes' to upload pay stubs";

  const normalizedPayrollEmployers = useMemo(() => {
    const payrollList = Array.isArray(payrollEmployers) ? payrollEmployers : [];
    const assignedSourceIds = new Set<number>();

    return payrollList
      .map((employer: any) => {
        const sourceId = parseSourceId(employer?.source_id);
        if (!sourceId || assignedSourceIds.has(sourceId)) return null;

        assignedSourceIds.add(sourceId);
        return { ...employer, source_id: sourceId };
      })
      .filter(Boolean);
  }, [payrollEmployers]);
  const plaidMonthlyGrossTotal = useMemo(
    () => (normalizedPayrollEmployers as any[]).reduce((sum, e) => sum + (e?.avgMonthlyGross ?? 0), 0),
    [normalizedPayrollEmployers]
  );

  const serverSourceStatusById = useMemo(
    () => mergeServerSourceStatuses(payrollSourceStatuses, argyleSourceStatuses, MAX_EMPLOYERS),
    [payrollSourceStatuses, argyleSourceStatuses]
  );
  const argyleValidationSourceIds = useMemo(() => {
    const sourceIds = new Set<number>();
    (Array.isArray(argyleSourceStatuses) ? argyleSourceStatuses : []).forEach(
      (item: any) => {
        const sourceId = parseSourceId(item?.source_id);
        const status = String(item?.status || "").trim().toLowerCase();
        if (
          sourceId &&
          (status === "pending" ||
            status === "linked_no_data" ||
            status === "linked")
        ) {
          sourceIds.add(sourceId);
        }
      }
    );
    return sourceIds;
  }, [argyleSourceStatuses]);
  const persistedSourceVerificationTypeById = useMemo(() => {
    const modeBySourceId = new Map<number, "chooser" | "document" | "payroll">();
    const sourceModes =
      IncomeAPIResponse?.data?.employment_details?.source_verification_modes;
    (Array.isArray(sourceModes) ? sourceModes : []).forEach((item: any) => {
      const sourceId = parseSourceId(item?.source_id ?? item?.sourceId);
      const verificationType = String(
        item?.verification_type ?? item?.verificationType ?? ""
      )
        .trim()
        .toLowerCase();
      if (!sourceId) return;
      if (
        verificationType !== "chooser" &&
        verificationType !== "document" &&
        verificationType !== "payroll"
      ) {
        return;
      }
      modeBySourceId.set(
        sourceId,
        verificationType as "chooser" | "document" | "payroll"
      );
    });
    return modeBySourceId;
  }, [IncomeAPIResponse?.data?.employment_details?.source_verification_modes]);

  const serverPendingSourceSet = useMemo(
    () =>
      new Set(
        Array.from(serverSourceStatusById.entries())
          .filter(
            ([, status]) => status === "pending" || status === "linked_no_data"
          )
          .map(([sourceId]) => sourceId)
      ),
    [serverSourceStatusById]
  );

  const serverValidSourceSet = useMemo(
    () =>
      new Set(
        Array.from(serverSourceStatusById.entries())
          .filter(([, status]) => status === "valid" || status === "linked")
          .map(([sourceId]) => sourceId)
      ),
    [serverSourceStatusById]
  );
  const pruneLocalPendingSources = (
    state: Record<number, { createdAt: number; acknowledgedByServer: boolean }>
  ) => {
    const now = Date.now();
    let changed = false;
    const next: Record<number, { createdAt: number; acknowledgedByServer: boolean }> = {};

    Object.entries(state).forEach(([sourceIdRaw, pendingState]) => {
      const sourceId = parseSourceId(sourceIdRaw);
      if (!sourceId) {
        changed = true;
        return;
      }

      const serverStatus = serverSourceStatusById.get(sourceId) || null;
      if (serverStatus === "valid" || serverStatus === "linked") {
        changed = true;
        return;
      }

      const serverPending =
        serverStatus === "pending" || serverStatus === "linked_no_data";
      const acknowledgedByServer = pendingState.acknowledgedByServer || serverPending;

      if (!serverPending && acknowledgedByServer) {
        changed = true;
        return;
      }

      if (
        now - pendingState.createdAt > LOCAL_PENDING_SOURCE_TTL_MS
      ) {
        changed = true;
        return;
      }

      const prev = state[sourceId];
      if (!prev || prev.acknowledgedByServer !== acknowledgedByServer) {
        changed = true;
      }

      next[sourceId] = {
        createdAt: pendingState.createdAt,
        acknowledgedByServer,
      };
    });

    return changed ? next : state;
  };

  useEffect(() => {
    setLocalPayrollPendingBySource((state) => pruneLocalPendingSources(state));
  }, [serverSourceStatusById]);

  useEffect(() => {
    argyleVerboseLog("proofIncome.pendingSources", {
      trn_id,
      localPayrollPendingBySource,
      serverPendingSourceIds: Array.from(serverPendingSourceSet.values()),
      serverValidSourceIds: Array.from(serverValidSourceSet.values()),
    });
  }, [trn_id, localPayrollPendingBySource, serverPendingSourceSet, serverValidSourceSet]);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setLocalPayrollPendingBySource((state) => pruneLocalPendingSources(state));
    }, 3000);

    return () => window.clearInterval(timer);
  }, [serverSourceStatusById]);

  const isSourcePayrollPending = (sourceId: number) => {
    if (serverValidSourceSet.has(sourceId)) return false;
    if (serverPendingSourceSet.has(sourceId)) return true;
    return Boolean(localPayrollPendingBySource[sourceId]);
  };

  const mergedSourceItems = useMemo<MergedSourceItem[]>(() => {
    const payrollBySource = new Map<number, any>();
    const documentBySource = new Map<
      number,
      { field: any; index: number; employerId: string; hasDocuments: boolean }
    >();
    const items: MergedSourceItem[] = [];

    normalizedPayrollEmployers.forEach((employer: any) => {
      const sourceId = parseSourceId(employer?.source_id);
      if (!sourceId || payrollBySource.has(sourceId)) return;
      payrollBySource.set(sourceId, {
        ...employer,
        source_id: sourceId,
      });
    });

    fields.forEach((field: any, index: number) => {
      const sourceId = parseSourceId(field?.EmployerNumber ?? field?.source_id);
      if (!sourceId || documentBySource.has(sourceId)) return;
      const employerId = String(field?.id ?? field?.EmployerNumber ?? index);
      const hasDocuments = Array.isArray(field?.files) && field.files.length > 0;
      documentBySource.set(sourceId, { field, index, employerId, hasDocuments });
    });

    for (let sourceId = 1; sourceId <= MAX_EMPLOYERS; sourceId += 1) {
      const payrollEmployer = payrollBySource.get(sourceId);
      if (payrollEmployer) {
        items.push({
          sourceId,
          kind: "payroll",
          payrollEmployer,
        });
        continue;
      }

      const documentSource = documentBySource.get(sourceId);
      if (!documentSource) continue;

      const persistedVerificationType =
        persistedSourceVerificationTypeById.get(sourceId);

      const showEmployerChooser =
        isPayrollPlaidEnabled &&
        !documentSource.hasDocuments &&
        !documentModeByEmployer[documentSource.employerId] &&
        persistedVerificationType !== "document";

      if (showEmployerChooser) {
        if (payrollValidationLoading) {
          items.push({ sourceId, kind: "loading" });
        } else {
          items.push({
            sourceId,
            kind: "chooser",
            field: documentSource.field,
            index: documentSource.index,
            employerId: documentSource.employerId,
          });
        }
        continue;
      } else {
        items.push({
          sourceId,
          kind: "document",
          field: documentSource.field,
          index: documentSource.index,
        });
      }
    }

    return items;
  }, [
    documentModeByEmployer,
    fields,
    isPayrollPlaidEnabled,
    payrollValidationLoading,
    normalizedPayrollEmployers,
    persistedSourceVerificationTypeById,
  ]);

  const occupiedSourceIds = useMemo(
    () => new Set<number>(mergedSourceItems.map((item) => item.sourceId)),
    [mergedSourceItems]
  );

  const combinedSourceCount = occupiedSourceIds.size;
  const isSourceProofComplete = (item: MergedSourceItem) => {
    const hasDocumentProof =
      item.kind === "document" &&
      Array.isArray(item.field?.files) &&
      item.field.files.length > 0;
    const hasPayrollProof =
      item.kind === "payroll" ||
      serverValidSourceSet.has(item.sourceId) ||
      isSourcePayrollPending(item.sourceId);
    return hasDocumentProof || hasPayrollProof;
  };
  const hasCompleteEmploymentProofForAllSources =
    combinedSourceCount > 0 &&
    mergedSourceItems.every((item) => isSourceProofComplete(item));
  const addEmployerButtonLabel =
    combinedSourceCount > 0 ? "Add another employer" : "Add Employer";

  const getNextEmployerSourceId = () => {
    for (let sourceId = 1; sourceId <= MAX_EMPLOYERS; sourceId += 1) {
      if (!occupiedSourceIds.has(sourceId)) return sourceId;
    }

    return null;
  };

  const createEmployerSource = () => {
    if (combinedSourceCount >= MAX_EMPLOYERS || isEmployerActionBusy()) return;

    const nextSourceId = getNextEmployerSourceId();
    if (!nextSourceId) return;

    lockEmployerActions();
    setdisableNewBtn(true);
    pendingAddSourceIdRef.current = nextSourceId;
    createNewEmployer({
      trn_id,
      document_id: "3",
      source_id: nextSourceId,
      verification_type: isPayrollPlaidEnabled ? "chooser" : "document",
    });
  };

  const employmentStatus = methods.watch("employment_status");
  const proofResponse = methods.watch("proof_response");
  const watchedEmployers = methods.watch()?.employer || [];
  const employmentSOCRStatusBySource: Record<string, any> =
    IncomeAPIResponse?.data?.employment_details?.SOCRstatus || {};
  // Same resource/id EmployerSource.tsx fetches per employer card - react-admin/react-query
  // dedupes this against those calls, so this adds no extra request.
  const { data: validationCheckForTotals } = useGetOne(
    "getEmployerValidationCheck",
    { id: trn_id },
    { enabled: trn_id != null, refetchOnWindowFocus: true }
  );
  // Unverifiable (SOCRStatus 2) employers must not count toward the displayed total.
  // Each employer is identified by its own source_id/EmployerNumber (normalized via
  // parseSourceId, same as methods.reset above) so this stays correct when sources are
  // non-contiguous (e.g. source 1 deleted, leaving sources 2 and 3). Array position is only
  // a last-resort fallback for entries missing both fields.
  // Status is read from both IncomeAPIResponse's SOCRstatus and the getEmployerValidationCheck
  // fallback, matching EmployerSource.tsx's "Overall" badge so this total never disagrees with it.
  const verifiedWatchedEmployers = watchedEmployers.filter(
    (employer: any, idx: number) => {
      const sourceNum =
        parseSourceId(employer?.source_id) ??
        parseSourceId(employer?.EmployerNumber) ??
        idx + 1;
      const status =
        employmentSOCRStatusBySource[`Source_${sourceNum}`] ??
        validationCheckForTotals?.other_check?.[`source_${sourceNum}`]?.SOCRStatus;
      return Number(status) !== 2;
    }
  );
  const docMonthlyGross = TotalGrossPay(verifiedWatchedEmployers);
  const totalMonthlyGross = docMonthlyGross + plaidMonthlyGrossTotal;
  const employmentNoDocReason = methods.watch("employment_no_doc_reason");
  const proofNoDocReason = methods.watch("proof_no_doc_reason");
  const employmentReasonDisplay = getReasonDisplayValue(
    employmentNoDocReason,
    methods.watch("employment_other_reason")
  );
  const proofReasonDisplay = getReasonDisplayValue(
    proofNoDocReason,
    methods.watch("proof_other_reason")
  );
  const hasEmployment = employmentStatus === "Yes";
  const hasNoEmploymentSelected = employmentStatus === "No";
  const hasProofToUpload = hasEmployment && proofResponse === "Yes";
  const hasNoProofSelected = hasEmployment && proofResponse === "No";
  const sectionAnswered =
    employmentStatus === "No" ||
    (employmentStatus === "Yes" && (proofResponse === "Yes" || proofResponse === "No"));

  const openEmploymentNoReasonModal = (clearEmploymentStatusOnCancel = true) => {
    setClearEmploymentStatusOnNoReasonCancel(clearEmploymentStatusOnCancel);
    setPendingEmploymentNoReason(methods.getValues("employment_no_doc_reason") || "");
    setPendingEmploymentOtherReason(
      String(methods.getValues("employment_other_reason") || "").slice(
        0,
        MAX_OTHER_REASON_LENGTH
      )
    );
    setEmploymentNoReasonModalOpen(true);
  };

  const handleCancelEmploymentNoReasonModal = () => {
    setEmploymentNoReasonModalOpen(false);
    if (clearEmploymentStatusOnNoReasonCancel) {
      methods.setValue("employment_status", "", {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  };

  const handleConfirmEmploymentNoReasonModal = () => {
    if (!pendingEmploymentNoReason) return;
    if (
      isOtherReason(pendingEmploymentNoReason) &&
      !pendingEmploymentOtherReason.trim()
    ) {
      return;
    }

    methods.setValue("employment_status", "No", {
      shouldDirty: true,
      shouldValidate: true,
    });
    methods.setValue("employment_no_doc_reason", pendingEmploymentNoReason, {
      shouldDirty: true,
      shouldValidate: true,
    });
    methods.setValue(
      "employment_other_reason",
      isOtherReason(pendingEmploymentNoReason)
        ? sanitizeOtherReason(pendingEmploymentOtherReason)
        : null,
      {
        shouldDirty: true,
        shouldValidate: true,
      }
    );
    OnSubmitIncome(methods.getValues());
    setEmploymentNoReasonModalOpen(false);
  };

  const openProofNoReasonModal = (clearProofResponseOnCancel = true) => {
    setClearProofResponseOnNoReasonCancel(clearProofResponseOnCancel);
    setPendingProofNoReason(methods.getValues("proof_no_doc_reason") || "");
    setPendingProofOtherReason(
      String(methods.getValues("proof_other_reason") || "").slice(
        0,
        MAX_OTHER_REASON_LENGTH
      )
    );
    setProofNoReasonModalOpen(true);
  };

  const handleCancelProofNoReasonModal = () => {
    setProofNoReasonModalOpen(false);
    if (clearProofResponseOnNoReasonCancel) {
      methods.setValue("proof_response", "", {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  };

  const handleConfirmProofNoReasonModal = () => {
    if (!pendingProofNoReason) return;
    if (isOtherReason(pendingProofNoReason) && !pendingProofOtherReason.trim()) return;

    methods.setValue("proof_response", "No", {
      shouldDirty: true,
      shouldValidate: true,
    });
    methods.setValue("proof_no_doc_reason", pendingProofNoReason, {
      shouldDirty: true,
      shouldValidate: true,
    });
    methods.setValue(
      "proof_other_reason",
      isOtherReason(pendingProofNoReason)
        ? sanitizeOtherReason(pendingProofOtherReason)
        : null,
      { shouldDirty: true, shouldValidate: true }
    );
    OnSubmitIncome(methods.getValues());
    setProofNoReasonModalOpen(false);
  };

  const handleEmploymentStatusChange = (value: string) => {
    if (value === "Yes" && isEmployerActionBusy()) return;
    if (value === "No") {
      const wasAlreadyNo = methods.getValues("employment_status") === "No";
      methods.setValue("employment_status", "No", {
        shouldDirty: true,
        shouldValidate: true,
      });
      openEmploymentNoReasonModal(!wasAlreadyNo);
      return;
    }

    const wasNo = methods.getValues("employment_status") === "No";
    methods.setValue("employment_status", value, {
      shouldDirty: true,
      shouldValidate: true,
    });
    if (value === "Yes" && wasNo) {
      OnSubmitIncome(methods.getValues());
    }
  };

  const handleProofResponseChange = (value: string) => {
    if (value === "Yes" && isEmployerActionBusy()) return;
    if (value === "Yes") {
      methods.setValue("proof_response", "Yes", {
        shouldDirty: true,
        shouldValidate: true,
      });

      if (
        combinedSourceCount === 0 &&
        !loadingcreateNewEmployer &&
        !hasAutoCreatedEmployer
      ) {
        setHasAutoCreatedEmployer(true);
        createEmployerSource();
      }
      OnSubmitIncome(methods.getValues());
      return;
    }

    const wasAlreadyNo = methods.getValues("proof_response") === "No";
    methods.setValue("proof_response", "No", {
      shouldDirty: true,
      shouldValidate: true,
    });
    openProofNoReasonModal(!wasAlreadyNo);
  };

  const handleEnableDocumentMode = (
    employerId: string | number,
    employerIndex?: number,
    options?: { precheckOfferLetter?: boolean }
  ) => {
    setDocumentModeByEmployer((previous) => ({
      ...previous,
      [String(employerId)]: true,
    }));

    if (options?.precheckOfferLetter && Number.isInteger(employerIndex)) {
      const offerLetterField =
        `employer.${employerIndex}.allowOfferLetter` as `employer.${number}.allowOfferLetter`;
      methods.setValue(offerLetterField, true, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }

    const values = methods.getValues();
    const idx = employerIndex;
    if (
      typeof idx === "number" &&
      Number.isInteger(idx) &&
      Array.isArray(values?.employer) &&
      values.employer[idx]
    ) {
      values.employer[idx] = {
        ...values.employer[idx],
        force_document_mode: true,
      } as any;
    }
    OnSubmitIncome(values as any);
  };

  const [buttonVisible, setButtonVisible] = useState(true);
  const handleDeleteEmployer = (overrideSourceId?: number) => {
    if (isEmployerActionBusy()) return;
    const sourceIdToDelete = overrideSourceId || employerNumber;

    if (sourceIdToDelete !== 0) {
      lockEmployerActions();
      employerProcessing({
        document_id: 3,
        source_id: null,
        employer_id: sourceIdToDelete,
        trn_id: trn_id,
        subUrl: "/income/deleteSource",
      });
      setButtonVisible(false);
      setTimeout(() => {
        setButtonVisible(true);
      }, 5000);
      // .then(_ => {
      //   handleAPIDebounced();
      // })
    }

  };

  const handleReprocessEmployer = async (index, employer_id) => {
    //
    const paystub_type = methods.watch(`employer.${index}.correctedDocType`);
    if (paystub_type) {
      employerProcessing({
        subUrl: "/income/reprocessEmployer",
        trn_id: trn_id,
        document_id: "3",
        employer_id: employer_id,
        new_type: paystub_type?.value,
        method: "POST",
      });
      //
    } else {
      methods.setError(
        `employer.${index}.correctedDocType`,
        { type: "required", message: "required" },
        { shouldFocus: true }
      );
    }
  };

  const getSrcfromStatus = (socrValue) => {
    if (socrValue) {
      switch (Number(socrValue)) {
        case 1:
          return greenTick;
        case 2:
          return redTick;
        case 3:
          return overa;
      }
    } else {
      return overa;
    }
  };

  const getClassfromStatus = (socrValue) => {
    //
    if (socrValue) {
      switch (Number(socrValue)) {
        case 1:
          return "green-block bg-success";
        case 2:
          return "red-block bg-danger";
        case 3:
          return "brwn-block bg-warning";
      }
    } else {
      return "brwn-block";
    }
  };

  const gettextStylefromStatus = (socrValue) => {
    //
    if (socrValue) {
      switch (Number(socrValue)) {
        case 1:
          return "green-ltr";
        case 2:
          return "red-ltr";
        case 3:
          return "brown-ltr text-dark";
      }
    } else {
      return "brown-ltr";
    }
  };

  const handleAPIDebounced = useMemo(() => {
    return debouce(handleSubmitManual, 3000);
  }, []);

  const buildInitialQuestionValues = (employmentDetails: any) => {
    const hasExistingEmployers =
      Array.isArray(employmentDetails?.employer) && employmentDetails.employer.length > 0;
    const invitationTypeNormalized = String(invitationType || "")
      .trim()
      .toLowerCase();
    const isVrInvitation =
      invitationTypeNormalized === "2" ||
      invitationTypeNormalized === "doc upload" ||
      invitationTypeNormalized === "docupload";
    const employmentStatusRaw = employmentDetails?.employment_status;
    const proofResponseRaw = employmentDetails?.response;
    const hasQ1Stored =
      employmentStatusRaw === "Yes" || employmentStatusRaw === "No";

    let employmentStatus: "Yes" | "No" | "" = hasQ1Stored ? employmentStatusRaw : "";
    let proofResponse: "Yes" | "No" | "" =
      proofResponseRaw === "Yes" || proofResponseRaw === "No" ? proofResponseRaw : "";
    const hasLegacyNoReasonSignal =
      !!String(employmentDetails?.no_doc_reason || "").trim() ||
      !!String(employmentDetails?.other_reason || "").trim();

    if (!hasQ1Stored) {
      if (proofResponseRaw === "Yes" || (!proofResponseRaw && hasExistingEmployers)) {
        employmentStatus = "Yes";
        proofResponse = "Yes";
      } else if (proofResponseRaw === "No" && hasLegacyNoReasonSignal) {
        employmentStatus = isVrInvitation ? "Yes" : "No";
        proofResponse = isVrInvitation ? "No" : "";
      } else if (proofResponseRaw === "No") {
        // Legacy default rows can carry response=No with no actual reason selected.
        // Treat these as unanswered so q2 does not auto-select "No" on fresh apps.
        proofResponse = "";
      }
    }

    const proofReasonMapped = mapReasonExactOrOther(
      employmentDetails?.no_doc_reason,
      employmentDetails?.other_reason,
      PROOF_REASON_VALUES,
      "other"
    );
    const employmentReasonMappedForStoredQ1 = hasQ1Stored
      ? mapReasonExactOrOther(
          employmentDetails?.employment_no_doc_reason,
          employmentDetails?.employment_other_reason,
          EMPLOYMENT_REASON_VALUES,
          "Other"
        )
      : { reason: null, other: null };

    if (employmentStatus === "Yes" && proofResponse === "Yes") {
      return {
        employment_status: "Yes",
        proof_response: "Yes",
        employment_no_doc_reason: employmentReasonMappedForStoredQ1.reason,
        employment_other_reason: employmentReasonMappedForStoredQ1.other,
        proof_no_doc_reason: proofReasonMapped.reason,
        proof_other_reason: proofReasonMapped.other,
      };
    }

    if (employmentStatus === "No") {
      const { reason: mappedEmploymentReason, other: mappedEmploymentOtherReason } =
        mapReasonExactOrOther(
          hasQ1Stored
            ? employmentDetails?.employment_no_doc_reason
            : employmentDetails?.no_doc_reason,
          hasQ1Stored
            ? employmentDetails?.employment_other_reason
            : employmentDetails?.other_reason,
          EMPLOYMENT_REASON_VALUES,
          "Other"
        );
      return {
        employment_status: "No",
        proof_response: "",
        employment_no_doc_reason: mappedEmploymentReason,
        employment_other_reason: mappedEmploymentOtherReason,
        proof_no_doc_reason: proofReasonMapped.reason,
        proof_other_reason: proofReasonMapped.other,
      };
    }

    if (employmentStatus === "Yes" && proofResponse === "No") {
      return {
        employment_status: "Yes",
        proof_response: "No",
        employment_no_doc_reason: employmentReasonMappedForStoredQ1.reason,
        employment_other_reason: employmentReasonMappedForStoredQ1.other,
        proof_no_doc_reason: proofReasonMapped.reason,
        proof_other_reason: proofReasonMapped.other,
      };
    }

    if (employmentStatus === "Yes") {
      return {
        employment_status: "Yes",
        proof_response: "",
        employment_no_doc_reason: employmentReasonMappedForStoredQ1.reason,
        employment_other_reason: employmentReasonMappedForStoredQ1.other,
        proof_no_doc_reason: proofReasonMapped.reason,
        proof_other_reason: proofReasonMapped.other,
      };
    }

    return {
      employment_status: "",
      proof_response: "",
      employment_no_doc_reason: null,
      employment_other_reason: null,
      proof_no_doc_reason: null,
      proof_other_reason: null,
    };
  };

  useEffect(() => {
    if (IncomeAPIResponse?.data?.employment_details) {
      const initialQuestionValues = buildInitialQuestionValues(
        IncomeAPIResponse?.data?.employment_details
      );
      const responseData = {
        ...IncomeAPIResponse?.data?.employment_details,
        ...initialQuestionValues,
        employer: IncomeAPIResponse?.data?.employment_details?.employer?.map(
          (item) => {
            const sourceId = parseSourceId(item?.source_id ?? item?.EmployerNumber);
            return {
              ...item,
              source_id: sourceId,
              no_doc_reason:
                item?.no_doc_reason ||
                "I don't currently have access to document(s), but can provide later",
            };
          }
        ),
      };

      methods.reset(responseData);

      const initialDocumentModes: Record<string, boolean> = {};
      responseData?.employer?.forEach((employer: any) => {
        if (employer?.id && Array.isArray(employer?.files) && employer.files.length > 0) {
          initialDocumentModes[String(employer.id)] = true;
        }
      });
      setDocumentModeByEmployer(initialDocumentModes);
      setHasAutoCreatedEmployer(
        Boolean(Array.isArray(responseData?.employer) && responseData.employer.length > 0)
      );
    }
  }, [IncomeAPIResponse?.data, invitationType]);

  const [collapse, setCollapse] = useState<string[]>([]);

  const [fileUploading] = useStore(`IncomeUpload_loading`);
  const [expandIncomeSection, setExpandIncomeSection] = useState(true);
  useEffect(() => {
    if (role === "applicant") setExpandIncomeSection(true);
  }, [role]);


  useEffect(() => {
    if (hasProofToUpload) setExpandIncomeSection(true);
  }, [hasProofToUpload]);

  // Removed auto-expansion of employer sections; they now start collapsed and rely on user toggle.

  const [userCloseBrowser, setUserCloseBrowser] = useState(false);
  return (
    <>

      <FormProvider {...methods}>
        <form
          method="POST"
          onSubmit={methods.handleSubmit(
            role === "applicant" ? OnSubmitIncome : OnSubmitIncome
          )}
        >
          <fieldset
            disabled={
              employerActionLocked ||
              loadingcreateNewEmployer ||
              deleteemployerProcessing ||
              fileUploading
            }
          >
            <div
              className="info-toggle"
              id={`employment-income-anchor-${trn_id}`}
              style={{ scrollMarginTop: "96px" }}
            >
              <div className="toggle-heads">
                <div
                  className="income-wrap d-flex justify-content-between align-items-center"
                >
                  <div className="d-flex align-items-center">
                    <b className="mx-3">Employment Income</b>
                    {props.required && <span className="new-star">*</span>}
                    <AlertDialogEmp bankLookbackMonths={bankLookbackMonths} />

                    <div className="subcontent p-1 pb-t10">
                      <div className="upload-subwrap">
                        {role == "applicant" && (
                          <p className="prf-upload">
                            Upload PDF Paystubs (Earnings Statements) Here
                          </p>
                        )}
                        {role != "applicant" && !hasProofToUpload && (
                            <p className="prf-upload">
                            <strong style={{ color: "#FF8585" }}>
                              Note:{" "}
                            </strong>
                              No income provided
                          </p>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end align-items-center">
                    <div className="month-inc">
                      {hasProofToUpload && (
                          <b className="fw-normal sub-text">
                            <>
                              Monthly Gross Pay:{" "}
                              <NumericFormat
                                thousandSeparator={","}
                                style={{ fontSize: 16 }}
                                prefix={"$"}
                                decimalScale={2}
                                displayType={"text"}
                                value={totalMonthlyGross}
                              />
                              &nbsp;&nbsp;
                            </>
                          </b>
                        )}
                    </div>
                    <div className="print-show">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                    {role !== "applicant" && (
                      <IconButton
                        className="m-1 print-hide"
                        onClick={() => setExpandIncomeSection((v) => !v)}
                        color="primary"
                      >
                        {!expandIncomeSection ? <AddIcon /> : <RemoveIcon />}
                      </IconButton>
                    )}
                  </div>
                </div>

                <div
                  className={` ${!expandIncomeSection ? "d-none" : "d-display"
                    } card-body cust-card-appl px-3`}
                >
                  <div className="d-flex align-items-center button-group">
                    <div style={{ flex: 1 }}>
                        <YesNoRadioButton
                        required={props.required}
                        label={EMPLOYMENT_STATUS_QUESTION}
                        source="employment_status"
                        disable={
                          employerActionLocked ||
                          loadingcreateNewEmployer ||
                          deleteemployerProcessing ||
                          IncomeAPIResponse?.isFetching
                        }
                        handleOnClick={(val) => {
                          if (!loadingcreateNewEmployer) {
                            handleEmploymentStatusChange(val);
                          }
                        }}
                      />
                    </div>
                  </div>

                  {hasNoEmploymentSelected && (
                    <div className="login-radio-types p-2 mb-2">
                      <div className="mb-1">
                        <p className="mb-0" style={reasonTextWrapStyle}>
                          <strong>Current situation:</strong>{" "}
                          {employmentReasonDisplay}
                          <button
                            type="button"
                            className="btn btn-link p-0 text-decoration-none print-hide"
                            aria-label="Edit current situation reason"
                            onClick={() => openEmploymentNoReasonModal(false)}
                            style={reasonEditButtonStyle}
                          >
                            <img src={pencilIcon} alt="" style={reasonEditIconStyle} />
                          </button>
                        </p>
                      </div>
                    </div>
                  )}

                  {hasEmployment && (
                    <div className="d-flex align-items-center button-group mt-2">
                      <div style={{ flex: 1 }}>
                        <YesNoRadioButton
                          required={props.required}
                          label={PROOF_OF_EMPLOYMENT_QUESTION}
                          source="proof_response"
                          disable={
                            employerActionLocked ||
                            loadingcreateNewEmployer ||
                            deleteemployerProcessing ||
                            IncomeAPIResponse?.isFetching
                          }
                          handleOnClick={(val) => {
                            if (!loadingcreateNewEmployer) {
                              handleProofResponseChange(val);
                            }
                          }}
                        >
                          <div className="row">
                            <div className="col-12">
                              <p className="component_title mb-1">
                                {proofYesHelperText}
                              </p>
                            </div>
                          </div>
                        </YesNoRadioButton>
                      </div>
                    </div>
                  )}

                  {hasProofToUpload && (
                    <div className="login-radio-types p-2 mb-2">
                      <div className="d-flex flex-column align-items-start" style={{ gap: 8 }}>
                        <div>
                          <p className="mb-1">
                            <strong>
                              {combinedSourceCount} employer
                              {combinedSourceCount === 1 ? "" : "s"} added
                            </strong>
                          </p>
                          <p className="mb-0">
                            You can add up to 3 employers.
                          </p>
                        </div>
                        {combinedSourceCount >= MAX_EMPLOYERS && (
                          <p className="mb-0" style={{ color: "#d32f2f" }}>
                            Maximum 3 employers reached.
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  <div className={sectionAnswered ? "login-radio-types p-2 mb-4" : "d-none"}>
                    {hasNoProofSelected && (
                      <div className="p-2">
                        <div className="mb-1">
                          <p className="mb-0" style={reasonTextWrapStyle}>
                            <strong>Reason:</strong> {proofReasonDisplay}
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none print-hide"
                              aria-label="Edit proof reason"
                              onClick={() => openProofNoReasonModal(false)}
                              style={reasonEditButtonStyle}
                            >
                              <img src={pencilIcon} alt="" style={reasonEditIconStyle} />
                            </button>
                          </p>
                        </div>
                      </div>
                    )}

                    {hasProofToUpload && mergedSourceItems.length > 0 && (
                      <div className="">
                        {mergedSourceItems.map((sourceItem) => {
                          const sourceAnchorId = `employment-source-${sourceItem.sourceId}`;
                          if (sourceItem.kind === "payroll") {
                            const payrollEmployer = sourceItem.payrollEmployer;
                            return (
                              <div id={sourceAnchorId} key={`payroll-source-${sourceItem.sourceId}`}>
                                <PlaidEmployerSource
                                  employer={payrollEmployer}
                                  displaySourceNumber={sourceItem.sourceId}
                                  role={role}
                                  payrollPending={isSourcePayrollPending(sourceItem.sourceId)}
                                  requiredLookbackWeeks={Number(LookbacksData?.paystub_lookback) || 0}
                                  trn_id={trn_id}
                                  applicationStatusUpdatedOn={props.applicationStatusUpdatedOn}
                                  validationMessages={props.argylePayrollValidationMessages}
                                />
                              </div>
                            );
                          }

                          if (sourceItem.kind === "chooser") {
                            const chooserValidationMessage = (
                              methods.formState?.errors?.employer?.[sourceItem.index] as any
                            )?.files?.message as string | undefined;
                            return (
                              <div id={sourceAnchorId} key={`chooser-source-${sourceItem.sourceId}`}>
                                <EmployerVerificationChooser
                                  employerIndex={sourceItem.sourceId - 1}
                                  employerName={sourceItem.field?.employer_name}
                                  trn_id={trn_id}
                                  sourceId={sourceItem.sourceId}
                                  validationMessage={chooserValidationMessage}
                                  payrollPending={isSourcePayrollPending(sourceItem.sourceId)}
                                  payrollPendingStatus={
                                    serverSourceStatusById.get(sourceItem.sourceId) || "none"
                                  }
                                  showArgyleValidationMessages={argyleValidationSourceIds.has(
                                    sourceItem.sourceId
                                  )}
                                  argyleValidationMessages={props.argylePayrollValidationMessages}
                                  role={role}
                                  onPayrollLinked={() => {
                                    setLocalPayrollPendingBySource((state) => ({
                                      ...state,
                                      [sourceItem.sourceId]: {
                                        createdAt: Date.now(),
                                        acknowledgedByServer:
                                          serverSourceStatusById.get(sourceItem.sourceId) ===
                                            "pending" ||
                                          serverSourceStatusById.get(sourceItem.sourceId) ===
                                            "linked_no_data",
                                      },
                                    }));
                                  }}
                                  deleting={deleteemployerProcessing || employerActionLocked}
                                  onDeleteSource={() => {
                                    const employerId = Number(sourceItem.field?.id);
                                    if (Number.isFinite(employerId)) {
                                      handleDeleteEmployer(employerId);
                                    }
                                  }}
                                  onSelectDocumentUpload={(options) =>
                                    handleEnableDocumentMode(
                                      sourceItem.employerId,
                                      sourceItem.index,
                                      options
                                    )
                                  }
                                />
                              </div>
                            );
                          }

                          if (sourceItem.kind === "loading") {
                            return null;
                          }

                          return (
                            <div id={sourceAnchorId} key={`document-source-${sourceItem.sourceId}`}>
                              <EmployerSource
                                field={sourceItem.field}
                                index={sourceItem.index}
                                mannualSOCRstatus={mannualSOCRstatus}
                                socrStatus={socrStatus}
                                serEmployerNumber={serEmployerNumber}
                                setConfirmDeleteSource={setConfirmDeleteSource}
                                methods={methods}
                                loadingdeleteEmployer={deleteemployerProcessing}
                                confirmDeleteSource={confirmDeleteSource}
                                meta_d_response={meta_d_response}
                                IncomeAPIResponse={IncomeAPIResponse}
                                role={role}
                                trn_id={trn_id}
                                handleDeleteEmployer={handleDeleteEmployer}
                                setButtonVisible={setButtonVisible}
                                buttonVisible={buttonVisible}
                                getSrcfromStatus={getSrcfromStatus}
                                getClassfromStatus={getClassfromStatus}
                                gettextStylefromStatus={gettextStylefromStatus}
                                refresh={refresh}
                                adminValidationMessages={adminValidationMessages}
                                invitationType={invitationType}
                                required={props.required}
                                handleAPIDebounced={handleAPIDebounced}
                                filePreview={filePreview}
                                setFilePreview={setFilePreview}
                                collapse={collapse}
                                setCollapse={setCollapse}
                                LookbacksData={LookbacksData}
                                handleReprocessEmployer={handleReprocessEmployer}
                                mlClassDetails={mlClassDetails}
                                applicationStatusUpdatedOn={props.applicationStatusUpdatedOn}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <br />
                  </div>
                  <Card>
                    <CardHeader sx={{ padding: 0 }} />
                  </Card>
                  <NoProofEmploymentReasonModal
                    open={employmentNoReasonModalOpen}
                    options={EMPLOYMENT_STATUS_NO_OPTIONS}
                    reason={pendingEmploymentNoReason}
                    otherReason={pendingEmploymentOtherReason}
                    onReasonChange={setPendingEmploymentNoReason}
                    onOtherReasonChange={setPendingEmploymentOtherReason}
                    onCancel={handleCancelEmploymentNoReasonModal}
                    onConfirm={handleConfirmEmploymentNoReasonModal}
                  />
                  <NoProofEmploymentReasonModal
                    open={proofNoReasonModalOpen}
                    options={LEGACY_PROOF_NO_OPTIONS}
                    reason={pendingProofNoReason}
                    otherReason={pendingProofOtherReason}
                    onReasonChange={setPendingProofNoReason}
                    onOtherReasonChange={setPendingProofOtherReason}
                    onCancel={handleCancelProofNoReasonModal}
                    onConfirm={handleConfirmProofNoReasonModal}
                  />
                  <Confirm
                    isOpen={userCloseBrowser && role !== "applicant"}
                    sx={{
                      "& .RaConfirm-iconPaddingStyle": { display: "none" },
                    }}
                    title="Do you want to save your changes?"
                    content={"If not saved your changes will be lost."}
                    onConfirm={() => {
                      OnSubmitIncome(methods.getValues());
                      setUserCloseBrowser(false);
                    }}
                    onClose={() => {
                      setUserCloseBrowser(false);
                    }}
                  />

                  <div className="d-flex justify-content-between print-hide mb-2">
                    {sectionAnswered && role != "applicant" ? (
                      <button
                        type="submit"
                        className="btn btn-primary print-hide mb-2"
                        style={{
                          backgroundColor: "rgb(45, 195, 232)",
                          color: "white",
                          marginLeft: 18,
                          padding: "8px 15px 8px 15px",
                        }}
                        ref={submitButtonRef}
                      >
                        {" "}
                        Save
                      </button>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>

                {hasProofToUpload &&
                  combinedSourceCount < MAX_EMPLOYERS && (
                    <div
                      className={` ${!expandIncomeSection ? "d-none" : "d-display"} collpase-ic-new text-start print-hide`}
                      style={{ paddingLeft: "9px" }}
                    >
                      <button
                        type="button"
                        className="btn btn-link text-decoration-none"
                        style={{
                          fontSize: "1rem",
                          fontFamily: "OpenSans-Bold",
                        }}
                        disabled={
                          disableNewBtn ||
                          employerActionLocked ||
                          loadingcreateNewEmployer ||
                          deleteemployerProcessing ||
                          !buttonVisible
                        }
                        onClick={createEmployerSource}
                      >
                        {addEmployerButtonLabel}
                      </button>
                    </div>
                  )}
              </div>
            </div>
          </fieldset>
        </form>
      </FormProvider>
    </>
  );
});

export default ProofOfEmploymentIncome;
